<template>
  <div id="surveyAnswer">
    <stu-breadcrumb :breadcrumbTitleName="$t('eval.teaEvaluation')" :breadcrumbLastName="$t('eval.teaEvaluation')"></stu-breadcrumb>
    <div class="maincon hasbg">
      <div class="contopbar">
        <p class="topbartitle">{{questionPaperName}}</p>
        <div class="topbarbtns">
          <button class="m-btn main" @click="goBack">{{$t("common.return")}}</button>
        </div>
      </div>
      <div class="subcon">
        <p class="questionIntro" v-if="questionPaperIntro">{{$t("survey.questionnaireDescription")}}：{{questionPaperIntro}}</p>
        <div v-for="(item1,index1) in surveyPaperData" :key="'q' + index1">
          <div
            class="questionGroup second-padding box_shadow"
            v-if="item1 && item1.wquestionList && item1.wquestionList.length"
          >
            <div class="groupIntro" v-if="item1.groupTitle != 'groupType:moren'">
              <!-- 一、教师评价，请对本次培训的老师各方面的表现作出评价。本部分共4题。 -->

              <span>{{item1.groupNo}}</span>、
              <span>{{item1.groupTitle}}</span>
            </div>
            <div
              v-for="(item,index) in item1.wquestionList"
              :key="'getStarParent'+index"
              :id="'getStarParent'+index"
            >
              <!--单选-->
              <div class="questionnaire-item multiple-choice" :class="{'pointer-none': isAnswered}"
               v-if="item.questionType == '1'">
                <div class="max-size item-tit">
                  <span v-if="item.inputRule.length!=0">*</span>
                  <span>{{index+1}}.</span>
                  <span>{{item.questionContent}}</span>
                </div>
                <div class="item-content">
                  <div
                    class="option-item"
                    v-for="(val,key) in item.wanswerItemList"
                    :key="'singleChoice' + key"
                  >
                    <el-radio
                      :name="'single_choice_'+index1+index"
                      :label="val.answerItemNo"
                      v-model="totalAnswer[index1].wquestionList[index].answerItemList"
                    >
                      <span>{{val.answerItemNo}}、{{val.answerItemContent}}</span>
                    </el-radio>
                  </div>
                  <div v-if="item.isAnother!=''" class="option-item">
                    <div v-if="!isAnswered">
                      <!-- <input
                        type="radio"
                        :name="'single_choice_'+index1+index"
                        value="Z"
                        v-model="totalAnswer[index1].wquestionList[index].answerItemList"
                      >
                      <span>
                        <label for>其他：</label>
                        <input
                          type="text"
                          v-model="totalAnswer[index1].wquestionList[index].restOption"
                        >
                      </span>-->
                    </div>
                    <div
                      v-else-if="isAnswered&&totalAnswer[index1].wquestionList[index].answerItemList!='Z'">
                      <el-radio
                        :name="'single_choice_'+index1+index"
                        :label="val.answerItemNo"
                        v-model="totalAnswer[index1].wquestionList[index].answerItemList">
                        {{$t("common.other")}}：
                        <input type="text">
                      </el-radio>
                    </div>
                    <div
                      v-else-if="isAnswered&&totalAnswer[index1].wquestionList[index].answerItemList=='Z'">
                      <el-radio
                        :name="'single_choice_'+index1+index"
                        :label="Z"
                        v-model="totalAnswer[index1].wquestionList[index].answerItemList">
                        {{$t("common.other")}}：
                        {{totalAnswer[index1].wquestionList[index].restOption}}
                      </el-radio>
                    </div>
                  </div>
                </div>
              </div>
              <!--多选-->
              <div class="questionnaire-item multiple-choice" :class="{'pointer-none': isAnswered}" v-if="item.questionType == '2'">
                <div class="max-size item-tit">
                  <span v-if="item.inputRule.length!=0">*</span>
                  <span>{{index+1}}.</span>
                  <span>{{item.questionContent}}</span>
                </div>
                <div class="item-content">
                  <div
                    class="option-item"
                    v-for="(val,key) in item.wanswerItemList"
                    :key="'multiple-choice' + key"
                  >
                    <el-checkbox
                      :label="index1+'-'+index+'-'+val.answerItemNo"
                      v-model="selectedMultipleItemNo"
                    >{{val.answerItemNo}}、{{val.answerItemContent}}</el-checkbox>
                  </div>
                  <div v-if="item.isAnother!=''" class="option-item">
                    <div v-if="!isAnswered">
                      <!-- <input
                        type="checkbox"
                        :name="'multiple_choice_'+index1+index"
                        :value="index1+'-'+index+'-'+'Z'"
                        v-model="selectedMultipleItemNo"
                      >
                      <span>
                        <label for>其他：</label>
                        <input
                          type="text"
                          v-model="totalAnswer[index1].wquestionList[index].restOption"
                        >
                      </span>-->
                    </div>
                    <div
                      v-else-if="isAnswered&&totalAnswer[index1].wquestionList[index].anotherMulti!='Z'">
                      <el-checkbox v-model="selectedMultipleItemNo">
                        {{$t("common.other")}}：
                        <input type="text">
                      </el-checkbox>
                    </div>
                    <div
                      v-else-if="isAnswered&&totalAnswer[index1].wquestionList[index].anotherMulti=='Z'">
                      <el-checkbox
                        label="Z"
                        v-model="totalAnswer[index1].wquestionList[index].anotherMulti"
                      >{{$t("common.other")}}：{{totalAnswer[index1].wquestionList[index].restOption}}</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <!--问答题-->
              <div class="questionnaire-item essay-question" v-if="item.questionType == '5'">
                <div class="max-size item-tit">
                  <span v-if="item.inputRule!=0">*</span>
                  <span>{{index+1}}.</span>
                  <span>{{item.questionContent}}</span>
                </div>
                <div
                  class="item-content"
                  v-if="totalAnswer[index1] && totalAnswer[index1].wquestionList && 
									totalAnswer[index1].wquestionList[index] && totalAnswer[index1].wquestionList[index].answerContent!=null"
                >
                  <textarea v-model="totalAnswer[index1].wquestionList[index].answerContent" :disabled="isAnswered" v-if="!isAnswered"></textarea>
                  <!-- 查看问卷问答题不显示输入框 -->
										<p class="item-answer" v-if="isAnswered" style="word-break:break-all;" v-html="$options.filters.rpEnter(totalAnswer[index1].wquestionList[index].answerContent)"></p>
                </div>
              </div>
              <!--评星题已做-->
              <div class="starAnswered" :class="{'pointer-none': isAnswered}" v-if="item.questionType == '3'">
                <div class="questionnaire-item">
                  <div class="max-size item-tit">
                    <span v-if="item.inputRule!=''">*</span>
                    <span>{{index+1}}.</span>
                    <span>{{item.questionContent}}</span>
                  </div>
                  <div class="item-content">
                    <div class="option-item">
                      <!-- <span
                        class="grade-icon"
                        :id="'getStar'+index"
                        v-if="nowAnswer[index] && nowAnswer[index].length"
                      >
                        <span
                          class="starActive"
                          v-for="n in parseInt(nowAnswer[index])"
                          :key="'starActive' + n"
                        ></span>
                        <span
                          class="star"
                          v-for="i in parseInt(5 - nowAnswer[index])"
                          :key="'star' + i"
                        ></span>
                      </span> -->
                      <span class="grade-icon" :id="'getStar'+index">
	                        <span class="starActive" v-for="n in parseInt(totalAnswer[index1].wquestionList[index].starNum)" :key="n"></span>
	                        <span class="star" v-for="n in 5-parseInt(totalAnswer[index1].wquestionList[index].starNum)" :key="n"></span>
	                    </span>
                    </div>
                  </div>
                </div>
              </div>

              <!--评分题-->
              <div class="questionnaire-item" :class="{'pointer-none': isAnswered}" v-if="item.questionType == '4'">
                <div class="max-size item-tit">
                  <span v-if="item.scoreFacing!='[]'">*</span>
                  <span>{{index+1}}.</span>
                  <span>{{item.questionContent}}（{{$t('survey.pleaseEnter')}}{{item.inputRule[0].split(',')[0]}}-{{item.inputRule[0].split(',')[1]}}{{$t('survey.theNumberBetween')}}）</span>
                </div>
                <div
                  class="item-content"
                  v-if="totalAnswer[index1] && totalAnswer[index1].wquestionList && 
									totalAnswer[index1].wquestionList[index] && totalAnswer[index1].wquestionList[index].answerContent!=null"
                >
                  <input
                    type="number"
                    pattern="[0-9]*"
                    v-model="totalAnswer[index1].wquestionList[index].answerContent"
                    v-if="!isAnswered"
                  >
                  <!-- 查看问卷评分题不显示输入框 -->
										<p v-if="isAnswered" style="word-break:break-all;">{{totalAnswer[index1].wquestionList[index].answerContent}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import stuBreadcrumb from "@/components/common/stuBreadcrumb";
export default {
  name: "surveyAnswer",
  data() {
    return {
      //问卷字段
      questionPaperName: "",
      questionPaperIntro: "",
      surveyPaperData: [],
      //答卷字段
      selectedMultiples: [], //多选回答集
      selectedMultipleItemNo: [], //多选序号
      answerContent: [], // 回答内容
      totalAnswer: [],
      //答卷字段
      groupList: [],
      isAnswered: false,
      nowAnswer: [],
      bizuoti: [],
      questionnaireName: "",
      aid: this.$route.query.aid, // 答卷id
      userId: localStorage.getItem("userId"),
      surveyId: this.$route.params.surveyId
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    selectedMultipleItemNo(curVal, oldVal) {
      let newItems = [];
      let l = [];
      let multiGroup = "";
      let multiNo = "";
      this.selectedMultiples = [];
      let listItems = this.selectedMultipleItemNo; //定义需要循环的数据
      let multiLinJson = {};
      if (listItems.length != 0) {
        listItems.forEach(function(item, index) {
          l = item.split("-");
          multiGroup = l[0];
          multiNo = l[1];
          let multiTotal = multiGroup + multiNo;
          let multiTotalJson = {};
          if (multiLinJson[multiTotal]) {
            let a = newItems[multiGroup][multiNo].concat([l[2]]);
            newItems[multiGroup][multiNo] = a;
            multiLinJson[multiTotal] = a;
          } else {
            multiTotalJson[multiNo] = "";
            newItems[multiGroup] = multiTotalJson;
            newItems[multiGroup][multiNo] = [l[2]];
            multiLinJson[multiTotal] = [l[2]];
          }
        });
        this.selectedMultiples = newItems;
        if (this.isAnswered == false) {
          this.totalAnswer[multiGroup].wquestionList[
            multiNo
          ].answerItemList = this.selectedMultiples[multiGroup][
            multiNo
          ].toString();
        }
      } else {
        l = oldVal[0].split("-");
        multiGroup = l[0];
        multiNo = l[1];
        if (this.isAnswered == false) {
          this.totalAnswer[multiGroup].wquestionList[multiNo].answerItemList =
            "";
        }
      }
    }
  },
  components: {
    stuBreadcrumb
  },
  filters: {
    rpEnter(el) {
      return el.replace(/\n/g, '<br>').replace(/\r\n/g, '<br>')
    }
  },
  methods: {
    // 初始化数据
    init() {
      if (!this.aid) {
        this.isAnswered = false;
        this.answerLoading();
      } else {
        this.isAnswered = true;
        this.answerLoading();
      }
    },
    // 返回
    goBack() {
      this.$router.go(-1);
    },
    answerLoading() {
      //请求问卷信息
      this.request
        .get(
          this.WITSBOX_ENV_PARAM.baseUrl +
            "/survey/surveyPaper/" +
            this.surveyId
        )
        .then(response => {
          if (!response.success) {
            return false;
          }
          let surveyData = response.dataModel.question;
          this.questionPaperName = surveyData.questionPaperName;
          this.questionnaireName = surveyData.libName;
          this.questionPaperIntro = surveyData.questionPaperIntro;
          this.surveyPaperData = surveyData.groupList;

          let vv = this;
          this.surveyPaperData.forEach(function(item, index) {
            let vvm = vv;
            item.wquestionList.forEach(function(itemi, indexi) {
              if (itemi.questionType == 4) {
                if (itemi.scoreFacing != "[]") {
                  vvm.bizuoti.push(index + "-" + itemi.questionNo);
                }
              } else {
                if (itemi.inputRule.length != 0) {
                  vvm.bizuoti.push(index + "-" + itemi.questionNo);
                }
              }
            });
          });
          if (this.isAnswered == true) {
            // 请求答卷信息
            this.nowAnswer = [];
            this.request
              .get(
                this.WITSBOX_ENV_PARAM.baseUrl +
                  "/survey/surveyAnswerPape/" +
                  this.aid
              )
              .then(res => {
                this.surveyAnswerData = res.dataModel.groupList;

                this.totalAnswer = this.surveyAnswerData;
                let vm = this;
                this.totalAnswer.forEach(function(item, index) {
                  item.wquestionList.forEach(function(itemi, indexi) {
                    if (itemi.questionType == "3") {
                      if (itemi.answerContent == "") {
                        // let starArr = [];
                        // starArr[indexi] = 0;
                        // vm.nowAnswer[index] = starArr;
                        vm.$set(vm.nowAnswer, indexi, "0");
                        itemi.starNum = 0;
                      } else {
                        // let starArr = [];
                        // starArr[indexi] = itemi.answerContent.slice(0,1);
                        // vm.nowAnswer[index] = starArr;
                        vm.$set(
                          vm.nowAnswer,
                          indexi,
                          itemi.answerContent.slice(0, 1)
                        );
                        let stars = itemi.answerContent.slice(0,1)
											  itemi.starNum = stars;
                      }
                    }
                    if (itemi.questionType == "2") {
                      if (itemi.answerItemList != "") {
                        if (itemi.answerItemList.indexOf(",")) {
                          let result = itemi.answerItemList.split(",");
                          result.forEach(function(iteml, indexl) {
                            if (iteml == "Z") {
                              itemi.anotherMulti = "Z";
                            }
                            let MultiAnswer =
                              index + "-" + indexi + "-" + iteml;
                            vm.selectedMultipleItemNo.push(MultiAnswer);
                          });
                        } else {
                          let MultiAnswer =
                            index + "-" + indexi + "-" + itemi.answerContent;
                          vm.selectedMultipleItemNo.push(MultiAnswer);
                          if (itemi.answerContent == "Z") {
                            itemi.anotherMulti = "Z";
                          }
                        }
                      }
                    }
                  });
                });
              });
          } else {
            this.totalAnswer = this.surveyPaperData;
          }
        });
    }
  }
  // beforeCreate() {
  //   document.getElementsByTagName("body")[0].className="has-main-bg";
  // },
  // beforeDestroy() {
  // 	document.body.removeAttribute("class","has-main-bg");
  // }
};
</script>

<style lang="scss" scoped>
.topbartitle {
  margin: 0 150px;
  text-align: center;
}
.questionIntro {
  margin: 10px 0;
  line-height: 24px;
  font-size: 14px;
  text-indent: 2em;
  word-break: break-word;
  padding: 0 15px;
}
.questionGroup {
  padding: 0 15px;
}
.groupIntro {
  font-size: 16px;
  font-weight: bold;
  color: #6d7cac;
  word-break: break-word;
  margin: 10px 0;
}
.item-tit {
  padding: 4px 0;
  line-height: 20px;
  font-size: 14px;
  font-weight: bold;
}
.item-content {
  padding: 5px 30px;
	font-size: 14px;
  input,
  input:focus {
    outline: none;
  }
  .option-item {
    line-height: 20px;
    font-size: 14px;
    padding: 8px 0;
    input[type="radio"],
    input[type="checkbox"] {
      margin-right: 5px;
    }
  }
  input[type="text"],
  input[type="number"] {
    width: 120px;
    display: inline-block;
    vertical-align: middle;
    height: 34px;
    line-height: 32px;
    padding: 0 8px;
    font-size: 14px;
    border: 1px solid #e3e9fb;
    border-radius: 3px;
  }
  textarea {
    display: block;
    border: 1px solid #e3e9fb;
    border-radius: 3px;
    height: 82px;
    line-height: 20px;
    padding: 4px 8px;
    font-size: 14px;
    width: 80%;
    resize: none;
    margin: 6px 0;
  }
  & > input[type="text"],
  & > input[type="number"] {
    margin: 6px 0;
  }
  .grade-icon {
    span {
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      background: center center / 100% 100%;
      &.starActive {
        background-image: url(../../assets/images/icons/starfull.png);
      }
      &.star {
        background-image: url(../../assets/images/icons/starempty.png);
      }
    }
  }
}

.pointer-none {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/survey/surveyAnswer.vue